import { render } from "./error-indicator.html?vue&type=template&id=6ffd0983&scoped=true&ts=true&external"
import script from "./error-indicator.ts?vue&type=script&lang=ts&external"
export * from "./error-indicator.ts?vue&type=script&lang=ts&external"

import "./error-indicator.scss?vue&type=style&index=0&id=6ffd0983&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ffd0983"]])

export default __exports__